import Accounts from "../views/accounts/Accounts"
import Services from "../views/merchants/Services"
import MerchantRequests from "../views/merchants/MerchantRequests"
import BankAccounts from "../views/merchants/BankAccounts"
import Transactions from "../views/transactions/Transactions"
import BulkPayments from "../views/transactions/BulkPayments"
import TopUps from "../views/transactions/TopUps"
import Issues from "../views/Issues"
import Raisings from "../views/raisings/Raisings"
import IdentityVerification from "../views/accounts/IdentityVerification"
import AccountsExport from "../views/accounts/Export.vue"
import MerchantsExport from "../views/merchants/Export.vue"
import ServiceExport from "@/views/merchants/ServiceExport.vue"

export default [
  {
    path: "/accounts",
    name: "accounts",
    component: {
      render(c) {
        return c("router-view")
      },
    },
    children: [
      {
        path: "users",
        name: "accounts.users",
        component: Accounts,
      },
      {
        path: "kyc",
        name: "accounts.kyc",
        component: IdentityVerification,
      },
      {
        path: "export",
        name: "accounts.export",
        component: AccountsExport,
      },
    ],
  },
  {
    path: "/transactions",
    name: "transactions",
    redirect: "/transactions/list",
    component: {
      render(c) {
        return c("router-view")
      },
    },
    children: [
      {
        path: "list",
        name: "transactions.list",
        component: Transactions,
      },
      {
        path: "bulk-payments",
        name: "transactions.bulk_payments",
        component: BulkPayments,
      },
      {
        path: "top-ups",
        name: "transactions.top_ups",
        component: TopUps,
      },
    ],
  },
  {
    path: "/issues",
    name: "issues",
    component: Issues,
  },
  {
    path: "/raisings/list",
    name: "raisings.list",
    component: Raisings,
  },
  {
    path: "/merchants",
    name: "merchants",
    redirect: "/merchants/services",
    component: {
      render(c) {
        return c("router-view")
      },
    },
    children: [
      {
        path: "services",
        name: "merchants.services",
        component: Services,
      },
      {
        path: "requests",
        name: "merchants.requests",
        component: MerchantRequests,
      },
      {
        path: "bank-accounts",
        name: "merchants.bank_accounts",
        component: BankAccounts,
      },
      {
        path: "export",
        name: "merchants.export",
        redirect: "/merchants/export/accounts",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "accounts",
            name: "merchants.export.accounts",
            component: MerchantsExport,
          },
          {
            path: "services",
            name: "merchants.export.services",
            component: ServiceExport,
          },
        ],
      },
    ],
  },
]
